import { defineComponent as i, ref as m, inject as u, watchEffect as s, onMounted as d, createBlock as c, createCommentVNode as f, openBlock as p, h, Comment as R } from "vue";
import { EditorContextService as a } from "@magnolia/frontend-helpers-base";
const B = /* @__PURE__ */ i({
  name: "EditableComment",
  __name: "EditableComment",
  props: {
    annotation: {},
    alwaysRender: { type: Boolean },
    shouldRefresh: { type: Boolean },
    shouldRunOnFrameReady: { type: Boolean }
  },
  setup(r) {
    const e = r, n = m(e.alwaysRender && !!e.annotation), o = u("magnoliaContext");
    s(() => {
      n.value && e.annotation && e.shouldRefresh && setTimeout(() => {
        a.refresh(), e.shouldRunOnFrameReady && a.onFrameReady();
      }, 0);
    }), d(() => {
      o != null && o.value.isMagnoliaEdit && !n.value && (n.value = !0);
    });
    const l = (t) => h(R, null, t.text);
    return (t, y) => n.value ? (p(), c(l, {
      text: t.annotation,
      key: t.annotation
    }, null, 8, ["text"])) : f("", !0);
  }
});
export {
  B as default
};
//# sourceMappingURL=vue-editor4.js.map
